import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromLeaveRequest from './leave-request.reducer';

export const selectLeaveRequestState = createFeatureSelector<fromLeaveRequest.State>(
  fromLeaveRequest.leaveRequestsFeatureKey
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = fromLeaveRequest.adapter.getSelectors(selectLeaveRequestState);
